const SIZE = 149;
const RADIUS = 60;
const STROKE_WIDTH = 18;
const CENTER = SIZE / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const ON_CART_COLOR = '#901de4';
const PENDING_COLOR = '#f2ff03';
const EMPTY_COLOR = '#e0e0e0';

type DonutChartProps = {
  onCartCount: number;
  pendingCount: number;
};

/**
 * Two-segment ring showing the proportion of required trays On cart vs.
 * Pending. No charting library exists in the repo (confirmed at CHECKPOINT
 * 2) — built as two overlaid stroked circles: pending fills the full ring,
 * on-cart is drawn on top starting at 12 o'clock for its exact fraction,
 * leaving the remainder showing through as pending. This gives exact
 * proportional arc lengths without gaps, matching the Figma donut asset.
 */
export const DonutChart = ({ onCartCount, pendingCount }: DonutChartProps) => {
  const total = onCartCount + pendingCount;
  const onCartFraction = total > 0 ? onCartCount / total : 0;
  const onCartLength = CIRCUMFERENCE * onCartFraction;

  return (
    <svg
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      width={SIZE}
      height={SIZE}
      data-testid="donut-chart"
      aria-hidden="true"
    >
      <circle
        cx={CENTER}
        cy={CENTER}
        r={RADIUS}
        fill="none"
        stroke={total > 0 ? PENDING_COLOR : EMPTY_COLOR}
        strokeWidth={STROKE_WIDTH}
        data-testid="donut-chart-pending-ring"
      />
      {onCartCount > 0 && (
        <circle
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          fill="none"
          stroke={ON_CART_COLOR}
          strokeWidth={STROKE_WIDTH}
          strokeDasharray={`${onCartLength} ${CIRCUMFERENCE - onCartLength}`}
          strokeLinecap="butt"
          transform={`rotate(-90 ${CENTER} ${CENTER})`}
          data-testid="donut-chart-on-cart-ring"
        />
      )}
    </svg>
  );
};
